import { apiFetch } from "./client";
import type { AnalyticsCohort } from "@batch-and-bowl/shared";

export interface AnalyticsContextResponse {
  householdAdults: number;
  householdKids: number;
  skillLevel: "beginner" | "intermediate" | "advanced";
  signupWeek: string;
  analyticsCohort: AnalyticsCohort;
  householdId: string | null;
}

export function getAnalyticsContext(): Promise<AnalyticsContextResponse> {
  return apiFetch<AnalyticsContextResponse>("/users/analytics-context");
}
